<div class="pc-ver-container">
  <div class="pc-ver-container-left" *ngIf="verticalData">
    <div class="pc-ver-head-content flex-box-vc-hl">
      <div class="col-des flex-box-vc-hl" title="{{descriptionTitle}}">{{descriptionTitle}}</div>
      <div class="col-date-year flex-box-vc-hr">
        <p class="no-marg" title="{{verticalData.years?.currentyear | date: 'MMMM d'}}">
          {{verticalData.years?.currentyear | date: 'MMMM d'}}
        </p>
        <p class="no-marg" title="{{verticalData.years?.currentyear | date: 'y'}}">
          {{verticalData.years?.currentyear | date: 'y'}}
        </p>
      </div>
      <div class="col-date-year latest-yr flex-box-vc-hr">
        <p class="no-marg" title="{{verticalData.years?.prevyear | date: 'MMMM d'}}">
          {{verticalData.years?.prevyear | date: 'MMMM d'}}
        </p>
        <p class="no-marg" title="{{verticalData.years?.prevyear | date: 'y'}}">
          {{verticalData.years?.prevyear | date: 'y'}}
        </p>
      </div>
    </div>
    <div class="pc-ver-body-content">
      <mat-accordion multi="true">
        <ng-container *ngFor="let panel of verticalData.partners; last as isLastOne;">
        <mat-expansion-panel  [expanded]="verticalPanelsState">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="exp-head">
                <span class="exp-head-title" title="{{panel.partnername}}">{{panel.partnername}}</span>
                <span class="exp-head-per" title="{{panel.allocationtypevalue}}">{{panel.allocationtypevalue}}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <ng-container *ngFor="let child of panel.childs; first as isFirst; last as isLast;">
              <li>
                <div class="custom-details" [ngClass]="{'cstm-border' : isFirst || isLast}">
                  <div class="col-status flex-box-vc-hl" *ngIf="child.issource == 1 else oldBlock">
                    <span class="status-label new">
                      <ng-container>NEW</ng-container>
                    </span>
                  </div>
                  <ng-template #oldBlock>
                    <div class="col-status flex-box-vc-hl"></div>
                  </ng-template>
                  <div class="vert-icon" *ngIf="!isFirst && !isLast else iconBlock">
                    <button mat-icon-button class="more-btn" [matMenuTriggerFor]="cfmenu" aria-label=""
                      #t="matMenuTrigger">
                      <i class="fa-regular fa-ellipsis-vertical more-actions"></i>
                    </button>
                    <mat-menu #cfmenu="matMenu" #afterMenu="matMenu" xPosition="after" class="vert-btns">
                      <button mat-menu-item title="Add" class="add-row-btn"
                              (click)="activeRow('ADD', panel.partnerid, child.parentid, child.partnershiplineitemid)">
                              <i class="fa-regular fa-rectangle-history-circle-plus add-row"></i>
                        <span>Add Row</span>
                      </button>
                      <button mat-menu-item title="Edit" class="add-row-btn" (click)="activeRow('EDIT', child)">
                        <i class="fa-regular fa-pen"></i>
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item *ngIf="child.issource == 1" title="Delete" class="add-row-btn"
                              (click)="confirm('DELETE', child);">
                              <i class="fa-regular fa-trash-can add-row"></i>
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                  <ng-template #iconBlock>
                    <div class="vert-icon"></div>
                  </ng-template>
                  <!--Edit row: open-->
                  <ng-container
                    *ngIf="isEditable && partnerId == child.partnerid && parentid == child.parentid && partnerShipLineItemId == child.partnershiplineitemid else notEditableBlock">
                    <div class="exp-open flex-box-vc-hl">
                      <div class="pc-add-col">
                        <input type="text" class="pc-txtfield form-control" [(ngModel)]="lineItemName"
                          autocomplete="off">
                      </div>
                    </div>
                    <div class="exp-currentyr flex-box-vc-hr">
                      <div class="pc-add-col pc-width">
                        <input type="text" class="pc-txtfield form-control" [(ngModel)]="curAmount" autocomplete="off"
                          (keypress)="onlyNumberKey($event)" title="Only numbers allowed!" style="position: relative; z-index: 0;text-align: right">
                      </div>
                    </div>
                    <div class="exp-previousyr flex-box-vc-hr">
                      <div class="pc-add-col pc-width">
                        <input type="text" class="pc-txtfield form-control" [(ngModel)]="preAmount" autocomplete="off"
                          (keypress)="onlyNumberKey($event)" title="Only numbers allowed!" style="position: relative; z-index: 0;text-align: right">
                      </div>
                    </div>
                    <div class="pc-cls-ok">
                        <button mat-button class="button-text pc-icon" title="Close" (click)="closeActiveRow('EDIT', child)">
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                        <button mat-button class="button-text pc-icon" title="Update" (click)="saveRow('UPDATE', 0, child)">
                            <i class="fa-regular fa-check"></i>
                        </button>
                    </div>
                  </ng-container>
                  <!--Edit row: end-->
                  <ng-template #notEditableBlock>
                    <div class="exp-open flex-box-vc-hl">
                      <p class="ellipse no-marg edit-item" [ngClass]="{'cstm-border' : isFirst || isLast}"
                        title="{{child.lineitemname}}">{{child.lineitemname}}</p>
                    </div>
                    <div class="exp-currentyr flex-box-vc-hr">
                      <p class="ellipse no-marg" title="{{child.curyearamount}}">
                        {{child.curyearamount}}</p>
                    </div>
                    <div class="exp-previousyr flex-box-vc-hr">
                      <p class="ellipse no-marg" title="{{child.preyearamount}}">
                        {{child.preyearamount}}</p>
                    </div>
                  </ng-template>
                </div>
              </li>
              <!--Enable New Row-->
              <li
                *ngIf="isRowAdded && partnerId == panel.partnerid && parentid == child.parentid && partnerShipLineItemId == child.partnershiplineitemid">
                <div class="custom-details">
                  <div class="col-status flex-box-vc-hl"></div>
                  <div class="vert-icon"></div>
                  <div class="exp-open pc-add-col flex-box-vc-hl">
                    <input class="pc-text" [(ngModel)]="lineItemName" autofocus autocomplete="off">
                  </div>
                  <div class="exp-currentyr pc-add-col flex-box-vc-hr">
                    <input class="pc-text txt-fld" [(ngModel)]="curAmount" autocomplete="off"
                      (keypress)="onlyNumberKey($event)" title="Only numbers allowed!" style="position: relative; z-index: 0;text-align: right">
                  </div>
                  <div class="exp-previousyr pc-add-col flex-box-vc-hr">
                    <input class="pc-text txt-fld" [(ngModel)]="preAmount" autocomplete="off"
                      (keypress)="onlyNumberKey($event)" title="Only numbers allowed!" style="position: relative; z-index: 0;text-align: right">
                  </div>
                  <div class="pc-cls-ok">
                    <button mat-button class="button-text pc-icon" title="Close" (click)="closeActiveRow('ADD')">
                        <i class="fa-regular fa-xmark"></i>
                    </button>
                    <button mat-button class="button-text pc-icon" title="Save" (click)="saveRow('ADD', child.parentid, panel.partnerid)">
                        <i class="fa-regular fa-check"></i>
                    </button>
                  </div>
                </div>
              </li>
            </ng-container>
            <!--Closing New Row-->
          </ul>
          <!--Closing Balance at the end: open-->
          <div class="custom-details cstm-border cstm-end-border" *ngIf="isLastOne">
            <div class="vert-icon"></div>
            <div class="col-status flex-box-vc-hl"></div>
            <div class="exp-open open-close flex-box-vc-hl">
              <p class="ellipse no-marg" title="Closing Balance at the end">Closing Balance at the end</p>
            </div>
            <div class="exp-currentyr open-close flex-box-vc-hr">
              <p class="ellipse no-marg" title="{{verticalData.closingamount.curamount}}">
                {{verticalData.closingamount.curamount}}</p>
            </div>
            <div class="exp-previousyr open-close flex-box-vc-hr">
              <p class="ellipse no-marg" title="{{verticalData.closingamount.prevamount}}">
                {{verticalData.closingamount.prevamount}}</p>
            </div>
          </div>
           <!--Closing Balance at the end: end-->
        </mat-expansion-panel>
      </ng-container>
      </mat-accordion>
    </div>
  </div>
</div>
<ng-template #confirmDialog>
  <div class="pd-dialog-delete">
    <div class="dialogboxheader">
      <div class="flex-box header-title">
        <h1 mat-dialog-title dialogbox class="flex-box no-marg">
            <i class="fa-regular fa-triangle-exclamation warning-msg"></i>
          <span>Delete</span>
        </h1>
      </div>
      <button class="transparent-btn float-right " [mat-dialog-close]>
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="delete-content">
      <p class="dialogbox">{{confirmMessage}}</p>
    </div>
    <div mat-dialog-actions>
      <div class="pd-delete-dialog-actions unap-yes-no">
        <button mat-flat-button mat-stroked-button class="float-left yesno-btn mar-r-16" color="secondary" [mat-dialog-close]>
          No
        </button>
        <button mat-flat-button class="float-right yesno-btn" color="primary" [mat-dialog-close]
                (click)="saveRow('DELETE')">
          Yes
        </button>
      </div>
    </div>
  </div>
</ng-template>
